export const preferredScrollBehavior = (): ScrollBehavior =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

export const headerScrollOffset = () =>
    (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--site-header-height')) || 64) + 16;

export const scrollToElement = (elementId: string, offset = headerScrollOffset(), behavior = preferredScrollBehavior()) => {
    const element = document.getElementById(elementId);
    if (!element) return false;

    window.scrollTo({
        top: Math.max(0, element.getBoundingClientRect().top + window.scrollY - offset),
        behavior,
    });
    return true;
};
